import { api } from "../lib/api";

export type AgingBucket = "not_yet_due" | "days_1_30" | "days_31_60" | "days_61_90" | "days_90_plus";

export interface AgingInvoiceLine {
  invoice_id: string;
  invoice_number: string | null;
  client_id: string;
  client_name: string;
  due_date: string;
  remainder_gbp: string;
  bucket: AgingBucket;
}

export interface AgingBucketTotal {
  bucket: AgingBucket;
  total_gbp: string;
  count: number;
}

export interface AgingReport {
  as_of: string;
  lines: AgingInvoiceLine[];
  bucket_totals: AgingBucketTotal[];
  grand_total_gbp: string;
}

export function getAgingReport(): Promise<AgingReport> {
  return api.get<AgingReport>("/api/reports/aging");
}

export interface ProjectIncomeLine {
  project_id: string | null;
  project_name: string;
  amount_gbp: string;
}

export interface ClientIncomeLine {
  client_id: string;
  client_name: string;
  amount_gbp: string;
  projects: ProjectIncomeLine[];
}

export interface IncomeByClientReport {
  start_date: string;
  end_date: string;
  clients: ClientIncomeLine[];
  total_gbp: string;
}

export interface IncomeByClientParams {
  startDate?: string;
  endDate?: string;
}

export function getIncomeByClientReport(params: IncomeByClientParams): Promise<IncomeByClientReport> {
  const query = new URLSearchParams();
  if (params.startDate) query.set("start_date", params.startDate);
  if (params.endDate) query.set("end_date", params.endDate);
  const qs = query.toString();
  return api.get<IncomeByClientReport>(`/api/reports/income-by-client${qs ? `?${qs}` : ""}`);
}
